<div class="profile-right-inner dynamicFieldDiv" id="dvProfile" *ngIf="DynamicFieldsData != null && DynamicFieldsData.length > 0">
  <div class="pr-sub-heading" *ngIf="HeaderText && HeaderText.trim().length > 0">
    <span>{{HeaderText}} </span>
  </div>
  <div class="row" id="dataModel">
    <div class="col-sm-11">
      <div class="profile-input-section">
        <div *ngFor="let dynField of DynamicFieldsData; let i = index">
          <div>
            <!-- Dropdown -->
            <div class="col-sm-6 col-field-height" *ngIf="dynField['DynFieldValueType'].toLowerCase() == 'd'">
              <div class="form-group">
                <label class="header" for="">{{dynField.DynFieldName}}
                  <span *ngIf="IsFieldEditable(dynField)" class="asterisk_span">
                    <i *ngIf="dynField['IsMandatory']" class="asterisk_input"></i>
                  </span>
                </label>
                <!-- If Editable -->
                <span *ngIf="IsFieldEditable(dynField)" id="{{dynField['EncodedFieldControlId']}}_span">

                  <input type="hidden" name="FieldValueArray_hdnfld" id="{{dynField['EncodedFieldControlId']}}_hdnfld" value="{{dynField['DynFieldId']}}"/>

                  <input type="hidden" id="{{dynField['EncodedFieldControlId']}}Permission_hdnfld" value="{{ dynField | fieldPermission }}"/>

                  <!-- Manual data for options -->
                  <select *ngIf="dynField['IsPopulateFromDataSource']==false" name="FieldValueArray" id="{{dynField['EncodedFieldControlId']}}"
                    class="form-control" (change)="ClearError(dynField['EncodedFieldControlId'])">
                    <option value='0'>{{bs.getResource('rbkey_SlctLBL')}}</option>
                    <option *ngFor="let optn of dynField['FieldSpecificData']" [value]="optn['DynFieldDataValue']" [selected]="optn['IsSelected']">{{optn['DynFieldDDataDisplayText']}}</option>
                  </select>
                  <!-- Datasource for options -->
                  <select *ngIf="dynField['IsPopulateFromDataSource']==true" name="FieldValueArray" id="{{dynField['EncodedFieldControlId']}}"
                    class="form-control" (change)="ClearError(dynField['EncodedFieldControlId'])">
                    <option value='0'>{{bs.getResource('rbkey_SlctLBL')}}</option>
                    <option *ngFor="let optn of dynField['FieldAutoPopulateData']" [value]="optn['Value']" [selected]="optn['IsSelected']">{{optn['DisplayText']}}</option>
                  </select>
                </span>
                <div id="{{dynField['EncodedFieldControlId']}}_Error" class="errorMsg" style="display: none;"></div>
                <!-- Not Editable -->
                <span *ngIf="!IsFieldEditable(dynField)">
                  <label class="data" for="">{{dynField['DisplayText']}}</label>
                </span>
              </div>
            </div>

            <div class="col-sm-6 col-field-height" *ngIf="dynField['DynFieldValueType'].toLowerCase() == 'm'">

              <div class="form-group">
                <label class="header" for="">{{dynField.DynFieldName}}
                  <span *ngIf="IsFieldEditable(dynField)" class="asterisk_span">
                    <i *ngIf="dynField['IsMandatory']" class="asterisk_input"></i>
                  </span>
                </label>
                <!-- If Editable -->
                <span *ngIf="IsFieldEditable(dynField)">

                  <input type="hidden" name="FieldValueArray_hdnfld" id="{{dynField['EncodedFieldControlId']}}_hdnfld" value="{{dynField['DynFieldId']}}"/>

                  <input type="hidden" id="{{dynField['EncodedFieldControlId']}}Permission_hdnfld" value="{{ dynField | fieldPermission }}"/>

                  <input type="hidden" id="{{dynField['EncodedFieldControlId']}}Value_hdnfld" value="{{dynField | multiselectSelectedItem}}"/>

                  <angular2-multiselect name="FieldValueArray" id="{{dynField['EncodedFieldControlId']}}" [data]="dynField['MultiSelectItems']"
                    [ngModel]="dynField['MultiSelectItemsSelected']" [settings]="{text: 'Select', selectAllText: 'Select All',unSelectAllText: 'Unselect All', enableSearchFilter: true,classes: 'myclass custom-class', badgeShowLimit: 1}"
                    (onSelect)="onItemSelect($event,dynField)" (onDeSelect)="OnItemDeSelect($event,dynField)" (onSelectAll)="onSelectAll($event,dynField)"
                    (onDeSelectAll)="onDeSelectAll($event,dynField)">
                  </angular2-multiselect>
                </span>
                <div id="{{dynField['EncodedFieldControlId']}}_Error" class="errorMsg" style="display: none;"></div>
                <!-- Not Editable -->
                <span *ngIf="!IsFieldEditable(dynField)">
                  <label class="data" for="">{{dynField['DisplayText']}}</label>
                </span>
              </div>

            </div>

            <!-- Calander -->
            <div class="col-sm-6 col-field-height" *ngIf="dynField['DynFieldValueType'].toLowerCase() == 'c'" [ngClass]="{'disablePointerEvent' : dynField['IsAutoPopulate']}">
              <div class="form-group">
                <label class="header" for="">{{dynField.DynFieldName}}
                  <span *ngIf="IsFieldEditable(dynField)" class="asterisk_span">
                    <i *ngIf="dynField['IsMandatory']" class="asterisk_input"></i>
                  </span>
                </label>
                <!-- If Editable -->
                <span *ngIf="IsFieldEditable(dynField)">

                  <input type="hidden" name="FieldValueArray_hdnfld" id="{{dynField['EncodedFieldControlId']}}_hdnfld" value="{{dynField['DynFieldId']}}"/>

                  <input type="hidden" id="{{dynField['EncodedFieldControlId']}}Permission_hdnfld" value="{{ dynField | fieldPermission }}"/>

                  <input type="text" name="FieldValueArray" id="{{dynField['EncodedFieldControlId']}}" class="form-control Dycalander" attr.can-edit="{{IsFieldEditable(dynField)}}"
                    readonly value="{{dynField['DisplayText']}}" (keypress)="ClearError(dynField['EncodedFieldControlId'])"
                    autocomplete="off">
                </span>
                <div id="{{dynField['EncodedFieldControlId']}}_Error" class="errorMsg" style="display: none;"></div>
                <!-- Not Editable -->
                <span *ngIf="!IsFieldEditable(dynField)">
                  <label class="data" for="">{{dynField['DisplayText']}}</label>
                </span>
              </div>
            </div>

            <div class="col-sm-6 col-full-field-height" *ngIf="dynField['DynFieldValueType'].toLowerCase() == 'r'" [ngClass]="{'disablePointerEvent' : dynField['IsAutoPopulate']}">
              <div class="form-group">
                <label class="header" for="">{{dynField.DynFieldName}}
                  <span *ngIf="IsFieldEditable(dynField)" class="asterisk_span">
                    <i *ngIf="dynField['IsMandatory']" class="asterisk_input"></i>
                  </span>
                </label>

              </div>
              <div class="form-group">
                <!-- If Editable -->
                <span *ngIf="IsFieldEditable(dynField)">
                  <input type="hidden" name="FieldValueArray_hdnfld" id="{{dynField['EncodedFieldControlId']}}_hdnfld" value="{{dynField['DynFieldId']}}"/>

                  <input type="hidden" id="{{dynField['EncodedFieldControlId']}}Permission_hdnfld" value="{{ dynField | fieldPermission }}"/>

                  <input type="hidden" id="{{dynField['EncodedFieldControlId']}}Value_hdnfld" value="{{dynField['DisplayText']}}" />

                  <!-- <span id="rtfBox{{dynField['DynFieldName']}}"> -->
                  <quill-editor name="FieldValueArray" id="{{dynField['EncodedFieldControlId']}}" (onContentChanged)="editorContentChanged($event, dynField)"
                    [modules]="editorConfig" [(ngModel)]="dynField['DisplayText']"></quill-editor>
                  <!-- </span> -->
                </span>
                <div id="{{dynField['EncodedFieldControlId']}}_Error" class="errorMsg" style="display: none;"></div>
                <!-- Not Editable -->
                <span *ngIf="!IsFieldEditable(dynField)">

                  <input type="hidden" name="FieldValueArray_hdnfld" id="{{dynField['EncodedFieldControlId']}}_hdnfld" value="{{dynField['DynFieldId']}}"/>

                  <input type="hidden" id="{{dynField['EncodedFieldControlId']}}Permission_hdnfld" value="{{ dynField | fieldPermission }}"/>

                  <input type="hidden" name="FieldValueArray" id="{{dynField['EncodedFieldControlId']}}" value="{{dynField['DisplayText']}}" />

                  <label class="data" for="" [innerHTML]="dynField['DisplayText']"></label>
                </span>
              </div>

            </div>

            <!-- If TextArea -->
            <div class="col-sm-6 col-full-field-height" *ngIf="dynField['DynFieldValueType'].toLowerCase() == 'a'" [ngClass]="{'disablePointerEvent' : dynField['IsAutoPopulate']}">
              <div class="form-group">
                <label class="header" for="">{{dynField.DynFieldName}}
                  <span *ngIf="IsFieldEditable(dynField)" class="asterisk_span">
                    <i *ngIf="dynField['IsMandatory']" class="asterisk_input"></i>
                  </span>
                </label>
                <!-- If Editable -->
                <span *ngIf="IsFieldEditable(dynField)">

                  <input type="hidden" name="FieldValueArray_hdnfld" id="{{dynField['EncodedFieldControlId']}}_hdnfld" value="{{dynField['DynFieldId']}}"/>

                  <input type="hidden" id="{{dynField['EncodedFieldControlId']}}Permission_hdnfld" value="{{ dynField | fieldPermission }}"/>

                  <textarea name="FieldValueArray" id="{{dynField['EncodedFieldControlId']}}" class="textarea-descriptive" data-mini="true"
                    rows="3" [attr.maxlength]="dynField['DynFieldMaxLength']" (keypress)="ClearError(dynField['EncodedFieldControlId'])" 
                    autocomplete="off">{{dynField['DisplayText']}}</textarea>
                </span>
                <div id="{{dynField['EncodedFieldControlId']}}_Error" class="errorMsg" style="display: none;"></div>
                <!-- Not Editable -->
                <span *ngIf="!IsFieldEditable(dynField)">

                  <input type="hidden" name="FieldValueArray_hdnfld" id="{{dynField['EncodedFieldControlId']}}_hdnfld" value="{{dynField['DynFieldId']}}"/>

                  <input type="hidden" id="{{dynField['EncodedFieldControlId']}}Permission_hdnfld" value="{{ dynField | fieldPermission }}"/>
                  <input type="hidden" name="FieldValueArray" id="{{dynField['EncodedFieldControlId']}}" value="{{dynField['DisplayText']}}" />

                  <label class="data" for="">{{dynField['DisplayText']}}</label>
                </span>
              </div>
            </div>

            <!-- File upload -->
            <div class="col-sm-6 col-full-field-height" *ngIf="dynField['DynFieldValueType'].toLowerCase() == 'f'">

              <div class="form-group">
                <label class="header" for="">{{dynField.DynFieldName}}
                  <span *ngIf="IsFieldEditable(dynField)" class="asterisk_span" id="{{dynField['EncodedFieldControlId']}}asterisk_span">
                    <i *ngIf="dynField['IsMandatory']" class="asterisk_input"></i>
                  </span>
                </label>
                <!-- If Editable -->
                <span *ngIf="IsFieldEditable(dynField)">

                  <input type="hidden" name="FieldValueArray_hdnfld" id="{{dynField['EncodedFieldControlId']}}_hdnfld" value="{{dynField['DynFieldId']}}"
                  />

                  <input type="hidden" id="{{dynField['EncodedFieldControlId']}}Permission_hdnfld" value="{{ dynField | fieldPermission }}"
                  />

                  <input type="hidden" id="{{dynField['EncodedFieldControlId']}}ImagePath_hdnfld" value="{{dynField['FilePath']}}" />
                  <span (click)="ClearError(dynField['EncodedFieldControlId'])">
                    <app-file-upload id="{{dynField['EncodedFieldControlId']}}" [fileUploadParam]="dynField | fileuploadParam"></app-file-upload>
                  </span>                  
                  <div *ngIf="dynField['IsImageType']==false">
                    <a href="javascript:void(0);" (click)="openFile(dynField)" class="FileLink">
                      <u>
                        <span>{{dynField['FileName']}}</span>
                      </u>
                    </a>
                  </div>
                </span>
                <div id="{{dynField['EncodedFieldControlId']}}_Error" class="errorMsg" style="display: none;"></div>
                <!-- Not Editable -->
                <span *ngIf="!IsFieldEditable(dynField)">
                  <a href="javascript:void(0);" (click)="openFile(dynField)" class="FileLink">
                    <img *ngIf="dynField['IsImageType']==true" class="img_Signature" style="height:50px !important" src="{{dynField['FilePath']}}" alt="" />
                  </a>
                  <a *ngIf="dynField['IsImageType']==false" href="javascript:void(0);" (click)="openFile(dynField)">
                    <u>
                      <span>{{dynField['FileName']}}</span>
                    </u>
                  </a>
                </span>
              </div>

            </div>

            <!-- Checkbox -->
            <div class="col-sm-6 col-field-height" *ngIf="dynField['DynFieldValueType'].toLowerCase() == 'y'">

              <div class="form-group">
                <label class="header" for="">{{dynField.DynFieldName}}
                  <span *ngIf="IsFieldEditable(dynField)" class="asterisk_span">
                    <i *ngIf="dynField['IsMandatory']" class="asterisk_input"></i>
                  </span>
                </label>
                <!-- If Editable -->
                <span *ngIf="IsFieldEditable(dynField)">

                  <input type="hidden" name="FieldValueArray_hdnfld" id="{{dynField['EncodedFieldControlId']}}_hdnfld" value="{{dynField['DynFieldId']}}"
                  />

                  <input type="hidden" id="{{dynField['EncodedFieldControlId']}}Permission_hdnfld" value="{{ dynField | fieldPermission }}"
                  />

                  <input *ngIf="dynField['DisplayText'].toLowerCase() == 'true'" type="checkbox" name="FieldValueArray" id="{{dynField['EncodedFieldControlId']}}" checked="{{dynField['DisplayText']}}"
                    value="{{dynField['DisplayText']}}" (change)="ClearError(dynField['EncodedFieldControlId'])">
                  
                  <input *ngIf="dynField['DisplayText'] == '' || dynField['DisplayText'].toLowerCase() == 'false'" type="checkbox" name="FieldValueArray" id="{{dynField['EncodedFieldControlId']}}" 
                    value="{{dynField['DisplayText']}}" (change)="ClearError(dynField['EncodedFieldControlId'])">
                  <span class="checkmark"></span>
                </span>
                <div id="{{dynField['EncodedFieldControlId']}}_Error" class="errorMsg" style="display: none;"></div>
                <!-- Not Editable -->
                <span *ngIf="!IsFieldEditable(dynField)">
                  <label class="data" for="">
                    <input *ngIf="dynField['DisplayText'].toLowerCase() == 'true'" type="checkbox"  checked="{{dynField['DisplayText']}}" value="{{dynField['DisplayText']}}" style="pointer-events: none;">
                    <input *ngIf="dynField['DisplayText'] == '' || dynField['DisplayText'].toLowerCase() == 'false'" type="checkbox" value="{{dynField['DisplayText']}}" style="pointer-events: none;">
                  <span class="checkmark"></span>
                </label>
                </span>
              </div>

            </div>

            <!-- Textbox -->
            <div class="col-sm-6 col-field-height" *ngIf="dynField['DynFieldValueType'].toLowerCase() == 't'" [ngClass]="{'disablePointerEvent' : dynField['IsAutoPopulate']}">
              <div class="form-group">
                <label class="header" for="">{{dynField.DynFieldName}}
                  <span *ngIf="IsFieldEditable(dynField)" class="asterisk_span">
                    <i *ngIf="dynField['IsMandatory']" class="asterisk_input"></i>
                  </span>
                </label>
                <!-- If Editable -->
                <span *ngIf="IsFieldEditable(dynField)">

                  <input type="hidden" name="FieldValueArray_hdnfld" id="{{dynField['EncodedFieldControlId']}}_hdnfld" value="{{dynField['DynFieldId']}}"/>

                  <input type="hidden" id="{{dynField['EncodedFieldControlId']}}Permission_hdnfld" value="{{ dynField | fieldPermission }}"/>


                  <!-- Any type Textbox -->
                  <input *ngIf="dynField['DynFieldTextBoxValueType'].toLowerCase()=='a'" type="text" name="FieldValueArray" id="{{dynField['EncodedFieldControlId']}}"
                    class="form-control" value="{{dynField['DisplayText']}}" [attr.maxlength]="dynField['DynFieldMaxLength']"
                    (keypress)="ClearError(dynField['EncodedFieldControlId'])" autocomplete="off">
                  <!-- Numeric type Textbox -->
                  <input *ngIf="dynField['DynFieldTextBoxValueType'].toLowerCase()=='n'" type="text" name="FieldValueArray" id="{{dynField['EncodedFieldControlId']}}"
                    class="form-control" value="{{dynField['DisplayText']}}" (keypress)="ClearError(dynField['EncodedFieldControlId']);IsNumeric($event)"
                    [attr.maxlength]="dynField['DynFieldMaxLength']" autocomplete="off">
                  <!-- Email type Textbox -->
                  <input *ngIf="dynField['DynFieldTextBoxValueType'].toLowerCase()=='e'" type="text" name="FieldValueArray" id="{{dynField['EncodedFieldControlId']}}"
                    class="form-control" value="{{dynField['DisplayText']}}" pattern="[a-zA-Z0-9][\w\.-]*[a-zA-Z0-9]@[a-zA-Z0-9][\w\.-]*[a-zA-Z0-9]\.[a-zA-Z][a-zA-Z\.]*[a-zA-Z]"
                    [attr.maxlength]="dynField['DynFieldMaxLength']" (keypress)="ClearError(dynField['EncodedFieldControlId'])"
                    autocomplete="off">
                  <!-- Custom type Textbox (Regular Expression) -->
                  <input *ngIf="dynField['DynFieldTextBoxValueType'].toLowerCase()=='c'" type="text" name="FieldValueArray" id="{{dynField['EncodedFieldControlId']}}"
                    class="form-control" value="{{dynField['DisplayText']}}" pattern="{{dynField['DynFieldTextBoxRegexExpression']}}"
                    [attr.maxlength]="dynField['DynFieldMaxLength']" (keypress)="ClearError(dynField['EncodedFieldControlId'])"
                    autocomplete="off">
                </span>
                <div id="{{dynField['EncodedFieldControlId']}}_Error" class="errorMsg" style="display: none;"></div>
                <!-- Not Editable -->
                <span *ngIf="!IsFieldEditable(dynField)">

                  <input type="hidden" name="FieldValueArray_hdnfld" id="{{dynField['EncodedFieldControlId']}}_hdnfld" value="{{dynField['DynFieldId']}}"/>

                  <input type="hidden" id="{{dynField['EncodedFieldControlId']}}Permission_hdnfld" value="{{ dynField | fieldPermission }}"/>
                  <input type="hidden" name="FieldValueArray" id="{{dynField['EncodedFieldControlId']}}" value="{{dynField['DisplayText']}}" />

                  <label class="data" for="">{{dynField['DisplayText']}}</label>
                </span>
              </div>
            </div>


          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="profile-right-inner dynamicFieldDiv" *ngIf="DynamicFieldsData == null || DynamicFieldsData.length == 0">
  {{bs.getResource('rbkey_NoAddtnlInfrmtnDsplyMsg')}}
</div>
